import React from "react";
import "./ContactCard2.css";
import Map from "../Map/Map";
import mapimage from "../../Assets/contact/location2.png";
import Pin from "../../Assets/contact/pin2.svg";
import greypin from "../../Assets/contact/pin-grey.svg";
import phone from "../../Assets/contact/phone.svg";
import gmail from "../../Assets/contact/gmail.svg";
import insta from "../../Assets/contact/insta.svg";
import linkedin from "../../Assets/contact/linkedin.svg";



function ContactCard2() {
  var w = window.innerWidth;
  var h = window.innerHeight;
  return (
    <div className="contactContainer">
      <div className="innerCard">
        <div className="leftCard">
          <div className="title">Contact Us</div>
          <div className="map">
            <a href="https://maps.app.goo.gl/Lf9yFhuTbzAcxTjH8" target="blank">
              <img className="mapImage" src={mapimage} alt="map" />
            </a>
            {/* <Map /> */}
            <div className="pin">
              <a
                href="https://maps.app.goo.gl/j9zGbpXJM3JnDnZt5"
                target="blank"
              >
                <img src={Pin} width={35} height={35} alt="pin icon" />
              </a>
            </div>
          </div>
        </div>
        <div className="rightCard">
          <div className="hoverCard1">
            <div className="title">Revamp Hive Studio</div>
            <div className="address">
            
                <div className="left">
                  <img src={greypin} width={25} height={25} alt="pin icon" />
                </div>
             

              <div className="right">
                <div>16/A Gokulam Main Road</div>
                <div>VV Mohalla</div>
                <div>Mysuru, Karnataka 570002</div>
              </div>
            </div>

            <div className="phones">
                <div className="left">
                  <img src={phone} width={25} height={25} alt="pin icon" />
                </div>

              <div className="right">
              
                <div className="phone2">
                  <a href="tel:+918073194553">+91 8073194553</a>
                </div>
              </div>
            </div>

            <div className="email">
              
                <div className="left">
                  <a href="mailto:info@revamphivestudio.in">
                    <img src={gmail} width={25} height={25} alt="pin icon" />
                  </a>
                </div>

              <div className="right">
                <a href="mailto:info@revamphivestudio.in">
                  info@revamphivestudio.in
                </a>
              </div>
            </div>

            <div className="socialLinks">
              <div className="linkedin">
                <a
                  href="https://www.linkedin.com/company/revamp-hive-studio/about/"
                  target="blank"
                >
                  <img
                    src={linkedin}
                    width={30}
                    height={30}
                    alt="linkedin icon"
                    className="linkedinIcon"
                  />
                </a>
              </div>

              <div className="instagram">
                <a
                  href="https://www.instagram.com/revamp_hive_studio?igshid=MzMyNGUyNmU2YQ%3D%3D"
                  target="blank"
                >
                  <img
                    src={insta}
                    width={25}
                    height={25}
                    alt="instagram icon"
                    className="instagramIcon"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="hoverCard">
          <div className="title">Revamp Hive Studio</div>

          <div className="address">
            <div className="left">
              <img src={greypin} width={25} height={25} alt="pin icon" />
            </div>
            <div className="right">
              <div>16/A Gokulam Main Road</div>
              <div>VV Mohalla</div>
              <div>Mysuru, Karnataka 570002</div>
            </div>
          </div>

          <div className="phones">
            <div className="left">
              <img src={phone} width={25} height={25} alt="pin icon" />
            </div>
            <div className="right">
             
              <div className="phone2">
                <a href="tel:+918073194553">+91 8073194553</a>
              </div>
            </div>
          </div>

          <div className="email">
            <div className="left">
              <a href="mailto:info@revamphivestudio.in">
                <img src={gmail} width={25} height={25} alt="pin icon" />
              </a>
            </div>
            <div className="right">
              <a href="mailto:info@revamphivestudio.in">
                info@revamphivestudio.in
              </a>
            </div>
          </div>

          <div className="socialLinks">
            <div className="linkedin">
              <a
                href="https://www.linkedin.com/company/revamp-hive-studio/about/"
                target="blank"
              >
                <img
                  src={linkedin}
                  width={30}
                  height={30}
                  alt="linkedin icon"
                  className="linkedinIcon"
                />
              </a>
            </div>

            <div className="instagram">
              <a
                href="https://www.instagram.com/revamp_hive_studio?igshid=MzMyNGUyNmU2YQ%3D%3D"
                target="blank"
              >
                <img
                  src={insta}
                  width={25}
                  height={25}
                  alt="instagram icon"
                  className="instagramIcon"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactCard2;
